import create from "zustand";

import { WebEnv } from "@/types/env.types";
import { DeepNonNullable } from "@/types/index.types";

type EnvStore = {
  webEnv: WebEnv | undefined;
  setWebEnv: (env: WebEnv) => void;
};

const useEnvStore = create<EnvStore>((set) => ({
  webEnv: undefined,
  setWebEnv: (envWeb: WebEnv) => set({ webEnv: envWeb }),
}));

type EnvData = DeepNonNullable<EnvStore>;

/**
 * Returns the env store data if a web environment exists. Use this to avoid having to check for falsy values when you know a web environment exists in a given context.
 * @returns The env store data
 */
const getEnvData = (): EnvData => {
  const { webEnv, ...rest } = useEnvStore.getState();

  if (!webEnv) {
    throw new Error("Web environment does not exist");
  }

  return {
    webEnv,
    ...rest,
  };
};

export { getEnvData, useEnvStore, type EnvData, type EnvStore };
